import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f04b8e7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-xs lg:text-sm" }
const _hoisted_2 = { class: "text-xs lg:text-sm" }
const _hoisted_3 = { class: "text-xs lg:text-sm" }
const _hoisted_4 = { class: "flex flex-wrap" }
const _hoisted_5 = { class: "flex items-center justify-between whitespace-nowrap" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "flex justify-end items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_n_spin = _resolveComponent("n-spin")!
  const _component_QuestionCircle20Filled = _resolveComponent("QuestionCircle20Filled")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_n_popover = _resolveComponent("n-popover")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_rb_checkbox = _resolveComponent("rb-checkbox")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_base_modal_desktop = _resolveComponent("base-modal-desktop")!

  return (_openBlock(), _createBlock(_component_base_modal_desktop, {
    label: _ctx.stats.localization?.close_the_cycle_on_the_market,
    show: _ctx.rbResetFixOrder.showModal,
    lightDark: false,
    "onUpdate:show": _ctx.rbResetFixOrder.close,
    onAfterLeave: _ctx.rbResetFixOrder.reset
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_rb_checkbox, {
          class: "mr-4",
          disabled: _ctx.rbResetFixOrder.loading || _ctx.buttonDisabled,
          label: _ctx.stats.localization['trade_statistics__stop_bot_after_operation'],
          checked: _ctx.rbResetFixOrder.stop_bot_after_fix_completed,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rbResetFixOrder.stop_bot_after_fix_completed) = $event))
        }, null, 8, ["disabled", "label", "checked"]),
        _createVNode(_component_n_button, {
          class: "text-white/90 rounded-md",
          onClick: _ctx.rbResetFixOrder.closeAtMarket,
          loading: _ctx.rbResetFixOrder.loading,
          disabled: _ctx.rbResetFixOrder.loading || _ctx.buttonDisabled,
          color: _ctx.gl.mainColor
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.refs.localization.dialogs.ok), 1)
          ]),
          _: 1
        }, 8, ["onClick", "loading", "disabled", "color"])
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.allBotsError)
        ? (_openBlock(), _createBlock(_component_n_alert, {
            key: 0,
            class: "rounded-md w-full mb-4",
            type: "error"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.stats.localization?.the_operation_completed_with_errors || 'Операция завершена с ошибками'), 1)
            ]),
            _: 1
          }))
        : (_ctx.someBotsError)
          ? (_openBlock(), _createBlock(_component_n_alert, {
              key: 1,
              class: "rounded-md w-full mb-4",
              type: "error"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.stats.localization?.some_bots_failed_to_complete_the_sale_at_market || 'У некоторых ботов не удалось завершить продажу по рынку'), 1)
              ]),
              _: 1
            }))
          : (_ctx.allBotsSuccess)
            ? (_openBlock(), _createBlock(_component_n_alert, {
                key: 2,
                class: "rounded-md w-full mb-4",
                type: "success"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.stats.localization?.reset_fix_order__the_operation_was_completed_successfully || 'Операция  успешно выполнена'), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
      _createElementVNode("section", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rbResetFixOrder.bots, (bot) => {
          return (_openBlock(), _createElementBlock("section", {
            key: bot.id,
            class: "mt-4 w-3/12 bots"
          }, [
            _createVNode(_component_n_card, {
              size: "small",
              bordered: false,
              class: "overflow-hidden shadow bg-white dark:bg-darkCardBg rounded-lg",
              segmented: {
                        content: true,
                        footer: 'soft'
                    }
            }, {
              default: _withCtx(() => [
                _createElementVNode("section", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    target: "_blank",
                    to: {name: 'trade-statistic.management', params: {id: bot.id}},
                    class: "text-main underline hover:no-underline"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" #" + _toDisplayString(bot.id), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  (bot.loading)
                    ? (_openBlock(), _createBlock(_component_n_spin, {
                        key: 0,
                        size: "tiny",
                        class: "ml-2"
                      }))
                    : _createCommentVNode("", true),
                  (bot.messages.length)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(bot.messages, (msg, idx) => {
                        return (_openBlock(), _createBlock(_component_n_popover, {
                          key: idx,
                          trigger: "hover",
                          placement: "top",
                          class: _normalizeClass(["rounded-md", msg.success ? 'bg-green-500' : 'bg-red-400'])
                        }, {
                          trigger: _withCtx(() => [
                            _createVNode(_component_n_icon, {
                              class: _normalizeClass(["cursor-pointer text-xl mx-2", msg.success ? 'text-green-500' : 'text-red-400'])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionCircle20Filled)
                              ]),
                              _: 2
                            }, 1032, ["class"])
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("section", null, [
                              _createElementVNode("span", {
                                class: "notes text-xs text-white",
                                innerHTML: msg.msg
                              }, null, 8, _hoisted_6)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"]))
                      }), 128))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1024)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["label", "show", "onUpdate:show", "onAfterLeave"]))
}